class DcSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-dc-slider-content]');
    this.slides = this.track ? [...this.track.children] : [];
    this.previous = root.querySelector('[data-dc-slider-prev]');
    this.next = root.querySelector('[data-dc-slider-next]');
    this.dots = [...root.querySelectorAll('[data-dc-slider-dot]')];
    this.live = root.querySelector('[data-dc-slider-live]');
    this.autoplay = root.dataset.dcSliderAutoplay === 'true';
    this.loop = root.dataset.dcSliderLoop !== 'false';
    this.delay = Number(root.dataset.dcSliderAutoplaySpeed || 5) * 1000;
    this.index = 0;

    if (!this.track || this.slides.length < 2 || root.dataset.dcSlider !== 'true') return;
    this.previous?.addEventListener('click', () => this.goTo(this.index - 1));
    this.next?.addEventListener('click', () => this.goTo(this.index + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dcSliderDot))));
    root.addEventListener('keydown', this.handleKeydown);
    root.addEventListener('mouseenter', this.stop);
    root.addEventListener('mouseleave', this.start);
    root.addEventListener('focusin', this.stop);
    root.addEventListener('focusout', this.start);
    this.goTo(0, false);
    this.start();
  }

  handleKeydown = (event) => {
    if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
    if (event.key === 'ArrowRight') this.goTo(this.index + 1);
  };

  goTo(index, announce = true) {
    const lastIndex = this.slides.length - 1;
    if (this.loop) {
      this.index = (index + this.slides.length) % this.slides.length;
    } else {
      this.index = Math.max(0, Math.min(index, lastIndex));
    }

    const target = this.slides[this.index];
    this.track.style.transform = `translateX(-${target.offsetLeft}px)`;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.index;
      slide.classList.toggle('is-active', active);
      active ? slide.setAttribute('aria-current', 'true') : slide.removeAttribute('aria-current');
    });
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
    if (!this.loop) {
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === lastIndex;
    }
    if (announce && this.live) this.live.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
  }

  start = () => {
    if (!this.autoplay || this.timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.delay);
  };

  stop = () => {
    window.clearInterval(this.timer);
    this.timer = undefined;
  };
}

const initializeDcSliders = (scope = document) => {
  scope.querySelectorAll('[data-dc-slider="true"]').forEach((root) => {
    if (root.dataset.dcSliderInitialized === 'true') return;
    root.dataset.dcSliderInitialized = 'true';
    new DcSlider(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeDcSliders());
document.addEventListener('shopify:section:load', (event) => initializeDcSliders(event.target));
